import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { AuthContext } from '../contexts/Auth'
import Loading from './Loading'
import { redirectToLogin } from '../utils/loginRedirect'

const ProtectedRoute = ({ component, ...rest }: any) => {
    const authContext = useContext(AuthContext)
    const routeComponent = (props: any) => {
        if (authContext.isLoading) return React.createElement(Loading, props)

        if (!authContext.isAuth) {
            // Keeps the query string (e.g. ?connect=return) so it survives the login round trip
            redirectToLogin()
            return React.createElement(Loading, props)
        }

        if (!authContext.userLoaded) return React.createElement(Loading, props)

        return authContext.validPhone ?
            React.createElement(component, props) :
            <Redirect to={{ pathname: '/setup' }} />
    };

    return <Route {...rest} render={routeComponent} />;
};

export default ProtectedRoute
